import React, { Fragment } from "react";
import { InputLabel, Grid, Input, TextField } from "@material-ui/core";
import inputComponentMask from "lib/inputMask";
import { withStyles } from "@material-ui/core/styles";
import ViewOnlyField from "components/Global/Fields/ViewOnlyField";

const styles = theme => ({
  label: {
    fontWeight: "bold",
    color: "black"
  }
});
class GridTextArea extends React.Component {
  render() {
    return (
      this.props.shouldShow && (
        <>
          <Grid item xs={3}>
            <InputLabel className={this.props.classes.label} htmlFor={this.props.name}>
              {this.props.label}
            </InputLabel>
          </Grid>
          <Grid item xs={4}>
            {!this.props.isEditing &&
              <ViewOnlyField value={this.props.value} />}
            {this.props.isEditing &&
              <TextField
                fullWidth
                id={this.props.name}
                name={this.props.name}
                value={this.props.value}
                multiline={this.props.multiline}
                label=""
                onChange={this.props.onChange}
                InputProps={{
                  inputComponent: inputComponentMask({
                    mask: this.props.mask
                  })
                }}
              />}
          </Grid>
        </>
      )
    );
  }
}

export default withStyles(styles, { withTheme: true })(GridTextArea);
